<div class="container-fluid">
  <div class="row">
    <div class="col-sm-4 pull-right text-right">
      <div class="container-fluid">
        <div class="row">
          <button pButton type="button" class="btn btn-default" (click)="dulplicateClick()" icon="pi pi-copy"></button>

          <button pButton type="button" class="btn btn-default" (click)="deleteClick()" icon="pi pi-trash"></button>
        </div>
        <div class="row">
          <a [href]="eventUrl" target="_blank">{{ 'events.detail.component.view-web-page' | translate }}</a>
        </div>
      </div>
    </div>

    <div class="col-sm-8">
      <h2>{{ event.EventName }}</h2>
      <p>{{ event.StartDate | date: 'fullDate' }}, {{ event.StartDate | date: 'shortTime' }}</p>
      <p>{{ event.Location }}</p>
    </div>
  </div>
</div>

<wlx-tabs>
  <wlx-tab [title]="'Dashboard'">
    <div class="mt-3">
      <button app-add-button [label]="'events.dashboard.component.new-registration-label' | translate | titlecase" (onClick)="newRegistration()">
      </button>
    </div>
  </wlx-tab>

  <wlx-tab [title]="'Registrations'"> Registrations Component Goes Here </wlx-tab>

  <wlx-tab [title]="'Attendees'"> Attendees Component Goes Here </wlx-tab>

  <wlx-tab [title]="'Settings'">
    <wlx-tabs>
      <wlx-tab [title]="'General Settings'"> General Settings Component Goes Here </wlx-tab>
      <wlx-tab [title]="'Event Items'"> Event Items Component Goes Here </wlx-tab>
      <wlx-tab [title]="'Registration Settings'"> Registration Settings Component Goes Here </wlx-tab>
      <wlx-tab [title]="'Promo Codes'"> Promo Codes Component Goes Here </wlx-tab>
    </wlx-tabs>
  </wlx-tab>
</wlx-tabs>
